export default __webpack_public_path__ + "static/media/logo.37aecf61.png";